import React, { useState, useEffect } from 'react';

const CurrencyInput = ({ value: initialValue = 0, onChange, onEnter, onEscape }) => {
    const [displayValue, setDisplayValue] = useState(`$ ${initialValue}`);

    useEffect(() => {
        setDisplayValue(`$ ${initialValue}`);
    }, [initialValue]);

    const handleChange = (e) => {
        const raw = e.target.value.replace(/\$\s?|[^0-9.]/g, '');
        setDisplayValue(raw ? `$ ${raw}` : '$ ');
        onChange(raw);
    };

    return (
        <input
            type="text"
            className="datatable-input currency-input bg-white border rounded "
            value={displayValue}
            onChange={handleChange}
            onClick={(e) => e.stopPropagation()}
            onKeyDown={(e) => {
                if (e.key === 'Enter' && onEnter) onEnter();
                if (e.key === 'Escape' && onEscape) onEscape();
            }}
        />
    );
};

export default CurrencyInput;
